export const shortenString = (str: string, length: number, affix?: string) => {
  if (!str) return '';
  if (str.length <= length) return str;
  return `${str.slice(0, length)}${affix || ''}`;
};
